import React from 'react'
import TemplateExterno from './interfaz/TemplateExterno'
import Template from './interfaz/Template';
import enConstruccion from '../img/Pagina_no_encontrada.svg'

export default function SinResultados() {
    return (
        <Template enlaces={false}
        contenido={
            <React.Fragment>  
                <center>
                <img width="24.5%" border="0" src={enConstruccion} alt=""/>
                
                </center>
            </React.Fragment>
        }>
        </Template>);
}

